import history from './history'
import massApproval from './massApproval'
import table from './table'

export default {
    saveSuccess: 'Maßnahme wurde erfolgreich gespeichert.',
    deleteProcess: 'Maßnahme löschen',
    deleteProcessNumberText: 'Möchten Sie die Maßnahme {number} wirklich löschen?',
    deleteProcessText: 'Möchten Sie diese Maßnahme wirklich löschen?',
    deleteProcessSuccess: 'Maßnahme wurde erfolgreich gelöscht.',
    deleteProcessError: 'Die Maßnahme konnte nicht gelöscht werden.',

    process: '',
    processId: '{id}',
    event: 'Maßnahme',
    subsidyTitle: 'Zuschuss',
    subsidyTitleDescription: 'Diese Daten werden dem Antragsteller über den Weiterleitungsvertrag und teilweise per Mail mitgeteilt.',
    subsidyMaxCalculated: 'Errechneter höchstmöglicher Zuschuss',
    subsidy_max_calculated: 'Errechente höchstmögliche Förderung',
    formProcess: 'Formular',
    formProcesses: 'Formulare',
    formProcessesCount: 'Keine Formulare|{count} Formular|{count} Formulare',
    noDocumentCouldBeExported: 'Es konnte kein Dokument zur Ansicht gefunden oder erzeugt werden.',
    exportError: 'Fehlende Vorlagen',
    additional: 'Weitere Informationen',
    documentsTooltip: 'Sieht Antragsteller',

    confirmLeave: 'Sie haben nicht gespeicherte Änderungen in dieser Maßnahme. Möchten Sie die Seite wirklich verlassen?',

    requiredFormType: {
        goal_agreement: {
            name: 'Zielvereinbarung',
            statusUnsigned: 'nicht unterschrieben',
            statusMissing: 'fehlt',
            linked: 'Für diese Maßnahme gilt folgende Zielvereinbarung:',
            unsigned: 'Die Zielvereinbarung wurde noch nicht unterschrieben.',
            missing: 'Für diese Maßnahme fehlt eine Zielvereinbarung. Die Maßnahme sollte erst bewilligt werden, wenn der Antragsteller für das gewählte Haushaltsjahr im gewählten Förderbereich eine Zielvereinbarung besitzt.'
        },
        transfer_agreement: {
            name: 'Weiterleitungsvertrag',
            statusUnsigned: 'nicht unterschrieben',
            statusMissing: 'fehlt',
            linked: 'Für diese Maßnahme gilt folgender Weiterleitungsvertrag:',
            unsigned: 'Der Weiterleitungsvertrag wurde noch nicht unterschrieben.',
            missing: 'Für diese Maßnahme fehlt ein Weiterleitungsvertrag. Die Maßnahme sollte erst bewilligt werden, wenn der Antragsteller für das gewählte Haushaltsjahr im gewählten Förderbereich einen Weiterleitungsvertrag besitzt.'
        },
        goal_achievement: {
            name: 'Auswertung',
            statusUnsigned: 'nicht unterschrieben',
            statusMissing: 'fehlt',
            linked: 'Für diese Maßnahme gilt folgende Auswertung:',
            unsigned: 'Die Auswertung wurde noch nicht unterschrieben.',
            missing: 'Für diese Maßnahme fehlt eine Auswertung. Die Maßnahme sollte erst bewilligt werden, wenn der Antragsteller für das gewählte Haushaltsjahr im gewählten Förderbereich eine Auswertung besitzt.'
        },
        final_approval: {
            name: 'Endbewilligung',
            statusUnsigned: 'nicht bestätigt',
            statusMissing: 'fehlt',
            linked: 'Für diese Maßnahme gilt folgende Endbewilligung:',
            unsigned: 'Die Endbewilligung wurde noch nicht bestätigt.',
            missing: 'Für diese Maßnahme fehlt eine Endbewilligung. Die Maßnahme sollte erst bewilligt werden, wenn der Antragsteller für das gewählte Haushaltsjahr im gewählten Förderbereich eine Endbewilligung besitzt.'
        },
        audit_note: {
            name: 'Prüfvermerk',
            statusUnsigned: 'nicht unterschrieben',
            statusMissing: 'fehlt',
            linked: 'Für diese Maßnahme gilt folgender Prüfvermerk:',
            unsigned: 'Der Prüfvermerk wurde noch nicht unterschrieben.',
            missing: 'Für diese Maßnahme fehlt ein Prüfvermerk. Die Maßnahme sollte erst bewilligt werden, wenn der Antragsteller für das gewählte Haushaltsjahr im gewählten Förderbereich einen Prüfvermerk besitzt.'
        }
    },

    requiredFormTypeCurrent: 'Dieses Dokument gehört zu der Maßnahme, die gerade geöffnet ist.',
    requiredFormTypeArchived: 'Archiviert am {date}.',
    requiredFormTypeMultiple: 'Für {year} gibt es mehrere Dokumente vom Typ „{name}“ ({numbers}). Pro Organisation und Jahr sollte es nur eins geben.',

    archivedAtTooltip: 'Seit diesem Zeitpunkt sind die Daten dieses Formulars archiviert. Spätere Änderungen an Maßnahme, Organisation oder Bankverbindung fließen nicht mehr ein.',

    requestMeasuresPerOrgaAndYear: {
        title: 'Maßnahmen für {organisation} im Jahr {year} ({count})',
        filter: 'Nur verknüpfte Maßnahmen',
        filterDescription: 'Maßnahmen mit eingegangenem Antrag, die nicht zurückgezogen oder storniert wurden. Mit diesem Stand würde ein neu erstellter Weiterleitungsvertrag rechnen.',
        archived: 'Archivierte Verträge enthalten den Stand vom Tag der Archivierung und können von dieser Liste abweichen.',
        empty: 'Keine Maßnahmen vorhanden.',
        counted: 'ja',
        notCounted: {
            aborted: 'nein (zurückgezogen oder storniert)',
            request_not_received: 'nein (Antrag nicht eingegangen)'
        },
        countedColumn: 'Verknüpft',
        total: 'Gesamt'
    },

    requester: 'Antragsteller',
    requestOf: 'Beantragt von',
    requestFor: 'für Förderprogramm',
    creatorUser: 'Ansprechperson',
    callOrganisation: 'Organisation aufrufen',
    mailCreatorUser: 'E-Mail an Ansprechperson',
    bankAccount: 'Bankverbindung',
    noOrganisation: 'Kein Antragsteller',
    noCreatorUser: 'Keine Ansprechperson',
    noBankAccount: 'Keine Bankverbindung',
    noCreditorNummer: 'Keine P5 Kreditorennummer',
    changeOrganisationCreditorNumberInfo: 'Änderungen an dieser Stelle werden direkt in die Organisationsdaten übernommen.',

    organisation_id: 'Organisations-ID',
    creator_user_id: 'Ersteller*in-ID',
    event_id: 'Maßnahmen-ID',
    year_id: 'Jahres-ID',
    serial_number: 'Lfd. Nummer',
    process_number: 'Ordnungsnummer',
    funding_program_id: 'Förderprogramm-ID',
    bank_account_id: 'Bankverbindungs-ID',

    startDate: 'Startdatum',
    start_date: 'Startdatum',
    endDate: 'Enddatum',
    end_date: 'Enddatum',
    location: 'Ort',
    title: 'Bezeichnung',
    daysTotal: 'Tage',
    totalDays: 'Tage',
    subsidyRate: 'Zuschuss-Quote',
    subsidy_rate: 'Zuschuss-Quote',

    totalCost: 'Gesamtkosten',
    total_cost: 'Gesamtkosten',
    subsidyMax: 'Höchstmögliche Förderung',
    subsidy_max: 'Höchstmögliche Förderung',
    subsidyAmount: 'Zuschusshöhe',
    subsidy_amount: 'Zuschusshöhe',
    subsidy_open_payment: 'Offene Zahlungen',

    comment: 'Anmerkungen',
    editorialComment: 'Änderungsbemerkungen',
    editorial_comment: 'Änderungsbemerkungen',
    internalComment: 'Interne Bemerkungen',
    internal_comment: 'Interne Bemerkungen',
    commentTooltip: 'Sieht Antragsteller und RP auf Zusatzliste',
    editorialCommentTooltip: 'Sieht Antragsteller',
    internalCommentTooltip: 'Nur für Verband',

    cancellationComment: 'Stornobemerkung',
    cancellation_comment: 'Stornobemerkung',
    editCancellationComment: 'Stornobemerkung bearbeiten',
    editCancellationCommentHelpText: 'Die Stornobemerkung wird nur gespeichert, wenn die Maßnahme gespeichert wird.',
    setCancellationComment: 'Stornobemerkung setzen',

    numberOfLockedFormFields: '{count} gesperrte Formularfelder|{count} gesperrtes Formularfeld|{count} gesperrte Formularfelder',
    editLockedFormFields: 'Gesperrte Formularfelder bearbeiten',
    editLockedFormFieldsHelpText: 'Hier können Sie die gesperrten Formularfelder bearbeiten. Diese Felder können vom Antragsteller nicht mehr bearbeitet werden.',
    setLockedFormFields: 'Gesperrte Formularfelder setzen',

    menu: {
        processBaseData: 'Grunddaten',
        processActivities: 'Historie'
    },

    copy: {
        slideOverTitle: 'Maßnahme kopieren',
        slideOverDescription: 'Hier können Sie einstellen, wie die Maßnahme kopiert werden soll.',
        copyProcess: 'Maßnahme kopieren',
        eventName: 'Name der Maßnahme',
        copyProcessSuccess: 'Maßnahme wurde erfolgreich kopiert.',
    },

    addDocuments: {
        slideOverTitle: 'Dokumente hinzufügen',
        slideOverDescription: 'Hier können Sie Dokumente zu dieser Maßnahme hinzufügen.',
        addDocuments: 'Dokumente hinzufügen',
        addDocumentsSuccess: 'Dokumente wurden erfolgreich hinzugefügt.',
    },

    documents: {
        deleteDocument: 'Dokument löschen',
        deleteDocumentText: 'Möchten Sie dieses Dokument wirklich löschen?',
        deleteSuccess: 'Das Dokument wurde erfolgreich gelöscht.',
        deleteError: 'Das Dokument konnte nicht gelöscht werden.',

        attached: 'Hinzugefügt',
        detached: 'Entfernt',
    },

    tools: {
        tools: 'Werkzeuge',
    },

    table,
    massApproval,
    history
}